import { render, staticRenderFns } from "./typelist.vue?vue&type=template&id=5edb7c2e&scoped=true&"
import script from "./typelist.vue?vue&type=script&lang=js&"
export * from "./typelist.vue?vue&type=script&lang=js&"
import style0 from "./typelist.vue?vue&type=style&index=0&id=5edb7c2e&lang=less&scoped=true&"
import style1 from "./typelist.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb7c2e",
  null
  
)

export default component.exports